module.exports = __webpack_public_path__ + "img/logo-3.5defc143.svg";